import React, { useEffect, useRef, useState } from "react";

import {
    Box,
    Chip,
    MenuItem,
    Select,
    Typography,
} from '@mui/material';

import { styled } from '@mui/material/styles';

const CustomSelect = styled(Select)(({ theme }) => ({
    fontSize: '12px',
    height: '35px',
    color: 'rgb(255, 255, 255)',
    '& .MuiOutlinedInput-notchedOutline': {
        border: '1px solid rgba(139, 142, 146, 1)',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(178, 235, 177, 1)',
        borderWidth: 1,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(178, 235, 177, 1)',
        borderWidth: 1,
    },
    '.MuiSvgIcon-root': {
        fill: 'white',
    },
    '&.Mui-focused .MuiSvgIcon-root': {
        fill: 'rgba(178, 235, 177, 1)',
    },
    '&.Mui-disabled .MuiSvgIcon-root': {
        fill: 'rgba(175, 175, 175, 1)',
    },
    '&.Mui-disabled .MuiSelect-select': {
        color: 'rgba(175, 175, 175, 1)',
        WebkitTextFillColor: 'rgba(175, 175, 175, 1)', // For Chrome/Safari
    },
    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(139, 142, 146, 1)',
        borderWidth: 1,
    },
}));


const CustomMenuItem = styled(MenuItem)({
    '&.MuiMenuItem-root': {
        margin: '4px',
        borderRadius: 4,
        fontSize: '12px',
        backgroundColor: 'rgba(0, 0, 0, 1)',
        color: 'rgba(255, 255, 255, 1)',
        border: '1px solid rgba(0, 0, 0, 1)',
        '&:hover': {
            backgroundColor: 'rgba(178, 235, 177, 0.08)',
        },
        '&.Mui-selected': {
            backgroundColor: 'rgba(178, 235, 177, 0.75)',
            color: 'rgba(0, 0, 0, 1)',
        },
    },
})


function SettingsDropDown(props) {

    const {
        description='',
        disabled=false,
        label='',
        multiple=false,
        onChange = () => {},
        options=[],
        original='',
        value='',
    } = props

    const [focused, setFocused] = useState(false);
    const [uncommittedChanges, setUncommittedChanges] = useState(false);

    useEffect(() => {
        original === value ? setUncommittedChanges(false) : setUncommittedChanges(true);
    }, [value, original])

    return (
        <Box
            display="flex"
            flexDirection="column"
            m={1}
            position='relative'
        >
            {
                uncommittedChanges && 
                <Box
                    position="absolute"
                    top={0}
                    left={0}
                    mx={-1}
                    my={0.8}
                >
                    <Box
                        width={5}
                        height={5}
                        borderRadius={5}
                        backgroundColor={'rgba(255, 193, 7, 1)'} // warning color (amber)
                    />
                </Box>
            }
            <Typography
                variant="subtitle2"
                fontWeight={900}
                fontSize="12px"
                sx={{
                    color: disabled ? 'rgba(175, 175, 175, 1)'
                        : focused ? 'rgba(178, 235, 177, 1)'
                        : 'rgba(255, 255, 255, 1)'
                }}
            >
                {label}
            </Typography>
            <Typography
                variant="subtitle2"
                fontWeight={600}
                fontSize="11px"
                color="rgb(150, 150, 150)"
            >
                {description}
            </Typography>
            <Box width="250px">
                <CustomSelect
                    fullWidth
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                backgroundColor: 'rgb(0,0,0)',
                                border: '1px solid rgba(139, 142, 146, 0.6)',
                                height: '250px'
                            },
                        },
                    }}
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                    value={value}
                    multiple={multiple}
                    onChange={(e) => onChange(e.target.value)}
                    disabled={disabled || false}
                    renderValue={
                        multiple
                        ?
                        (selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {selected.map((value, index) => {
                                return (
                                    <Chip
                                        variant="outlined"
                                        key={index}
                                        label={options.find(
                                            item => item.value === value
                                            )?.name
                                        }
                                    />
                                )
                                }
                                )}
                            </Box>
                        )
                        :
                        undefined
                    }
                >
                    {options.map((item, index) => (
                        <CustomMenuItem
                            key={index}
                            value={item?.value || item?.name}
                        >
                            {item.name}
                        </CustomMenuItem>
                    ))}
                </CustomSelect>
            </Box>
        </Box>
    );
}

export default SettingsDropDown;